import { translateLiteral } from '../../../i18n/translateHelper';
const DEFAULT_SENDER_OPTION = 'uruk_sender';

export const uiSchema = {
  'ui:order': ['type', 'senderInfo', 'auditLevel', 'openAction', 'phoneNumbers', 'emails', 'rawSubject', '*'],
  rawMessage: {
    'ui:field': 'RTEField'
  },
  emails: {
    items: {
      'ui:options': {
        inputType: 'email'
      }
    }
  },
  phoneNumbers: {
    items: {
      'ui:options': {
        inputType: 'tel'
      }
    }
  }
};

export const getSchema = (whitelist, signature) => ({
  type: 'object',
  properties: {
    type: {
      type: 'string',
      title: translateLiteral('certificate:createForm:type:title'),
      enumNames: [translateLiteral('certificate:createForm:type:email'), translateLiteral('certificate:createForm:type:sms')],
      enum: ['email', 'sms']
    },
    senderInfo: {
      type: 'string',
      title: translateLiteral('certificate:createForm:senderInfo'),
      enumNames: [translateLiteral('certificate:createForm:whitelist')].concat(whitelist),
      enum: [DEFAULT_SENDER_OPTION].concat(whitelist)
    },
    auditLevel: {
      type: 'string',
      title: translateLiteral('certificate:createForm:audit:level:title'),
      enumNames: [
        translateLiteral('certificate:createForm:audit:level:sent'),
        translateLiteral('certificate:createForm:audit:level:delivered'),
        translateLiteral('certificate:createForm:audit:level:opened')
      ],
      enum: ['sent', 'delivered', 'opened']
    },
    templateId: {
      type: 'string',
      title: 'Template',
      enum: []
    }
  },
  required: ['type', 'auditLevel', 'templateId'],
  dependencies: {
    auditLevel: {
      oneOf: [
        {
          properties: {
            auditLevel: {
              enum: ['opened']
            },
            openAction: {
              type: 'string',
              title: translateLiteral('certificate:createForm:audit:openAction:title'),
              enumNames: [
                translateLiteral('certificate:createForm:audit:openAction:approval'),
                translateLiteral('certificate:createForm:audit:openAction:otp'),
                translateLiteral('certificate:createForm:audit:openAction:signature')
              ],
              enum: ['approval', 'otp', 'signature']
            }
          },
          required: ['files', 'openAction']
        }
      ]
    }
  }
});
